import React, { useEffect, useState, useRef } from "react";
import "./cssBoiler.css";
import "./ModernHeader.css";
import Navbar from "./Navbar";
import Section from "./Section";
import me from "../assets/me.jpg";

function ModernHeader() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    document.title = "Yuvraj's Portfolio";
    setIsLoaded(true);
  }, []);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleContactClick = (type) => {
    setIsDropdownOpen(false);

    switch (type) {
      case "whatsapp":
        window.open("https://wa.me/918260485393", "_blank");
        break;
      case "linkedin":
        window.open("https://www.linkedin.com/in/yuvrajsoneja/", "_blank");
        break;
      case "email":
        window.location.href = "mailto:yuvrajdev20004@gmail.com";
        break;
      default:
        break;
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      // Use the global Locomotive Scroll instance
      if (window.locomotiveScrollInstance) {
        window.locomotiveScrollInstance.scrollTo(element);
      } else {
        // Fallback to native scroll
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <div className="modern-header-container">
      <div className="modern-header" id="header-home">
        <Navbar />

        <div className="hero-section">
          <div className="hero-content">
            {/* Personal Details - Left Side */}
            <div className="personal-details">
              <div className="greeting-badge">
                <span>Hello, I am</span>
              </div>

              <h1 className="hero-title">
                <span className="name">Yuvraj</span>
                <span className="title-text">
                  <span className="title-curly">I build systems that </span>
                  <span className="title-highlight">scale</span>
                  <span className="title-curly">.</span>
                </span>
              </h1>

              <div className="hero-buttons">
                <button
                  className="primary-btn"
                  onClick={() => scrollToSection("projects")}
                >
                  <i className="fas fa-briefcase"></i>
                  <span>View My Work</span>
                </button>

                <div className="contact-dropdown-container" ref={dropdownRef}>
                  <button
                    className="secondary-btn"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <i className="fas fa-paper-plane"></i>
                    <span>Say Hello!</span>
                    <i
                      className={`fas fa-chevron-down dropdown-arrow ${
                        isDropdownOpen ? "open" : ""
                      }`}
                    ></i>
                  </button>

                  <div
                    className={`contact-dropdown ${
                      isDropdownOpen ? "open" : ""
                    }`}
                  >
                    <div className="dropdown-content">
                      <button
                        className="dropdown-item"
                        onClick={() => handleContactClick("whatsapp")}
                      >
                        <i className="fab fa-whatsapp"></i>
                        <span>Connect me through WhatsApp</span>
                      </button>
                      <button
                        className="dropdown-item"
                        onClick={() => handleContactClick("linkedin")}
                      >
                        <i className="fab fa-linkedin"></i>
                        <span>Connect me through LinkedIn</span>
                      </button>
                      <button
                        className="dropdown-item"
                        onClick={() => handleContactClick("email")}
                      >
                        <i className="fas fa-envelope"></i>
                        <span>Connect me through Email</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Profile Picture - Right Side */}
            <div className="profile-section">
              <div className="profile-picture">
                <div className="profile-image">
                  <img src={me} alt="Yuvraj" className="profile-photo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll-arrow" onClick={() => scrollToSection("about")}>
          <div className="arrow-down"></div>
        </div>
      </div>

      <section>
        <Section />
      </section>
    </div>
  );
}

export default ModernHeader;
